export { useAppMediaQuery, useMediaQuery } from './useAppMediaQuery';
export type { IAppMediaQueries } from './useAppMediaQuery';
